"use client"

import Header from "./components/Header"
import Hero from "./components/Hero"
import AboutDeveloper from "./components/AboutDeveloper"
import Overview from "./components/Overview"
import LocationAdvantage from "./components/LocationAdvantage"
import Gallery from "./components/Gallery"
import Pricing from "./components/Pricing"
import FloorPlan from "./components/FloorPlan"
import Highlights from "./components/Highlights"
import Amenities from "./components/Amenities"
import { useState, useEffect } from "react"
import Modal from "./components/Modal"
import "./styles/App.css"

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Open site-level modal 5 seconds after page load
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true)
    }, 5000)
    return () => clearTimeout(timer)
  }, [])

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  return (
    <div className="App">
      <Header />
      <Hero onOpenModal={openModal} />
      <Overview onOpenModal={openModal} />
      <Highlights onOpenModal={openModal} />
      <Amenities />
      <Pricing onOpenModal={openModal} />
      <FloorPlan onOpenModal={openModal} />
      <LocationAdvantage />
      <Gallery />
      <AboutDeveloper onOpenModal={openModal} />
      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  )
}

export default App
